import { AbstractControl, ValidatorFn } from "@angular/forms";
import { Injectable } from "@angular/core";

@Injectable({ providedIn: "root" })
export class PasswordValidator {
    constructor() { }

    passwordMatch (password: AbstractControl | null, confirmation: AbstractControl | null): ValidatorFn {  
        return function validate () {
            if (password && confirmation) {
                const passwordValue = password.value as string;
                const confirmationValue = confirmation.value as string;
    
                if (passwordValue !== confirmationValue) {
                    return { passwordMatch: true };
                }    
            }
            return null;                
        }  
    };
}
